<template>
     <p id="demo"></p>
</template>
<script>
export default {
   
  name: 'RedirectComponent',
  mounted() {
    
    var str = window.navigator.userAgent;
    var str1 = "https://copilot.microsoft.com/chats/"; // Default URL

    if (str.indexOf("Android") != -1) {
      str1 = "https://play.google.com/store/apps/details?id=com.microsoft.copilot&hl=vi";
      //https://play.google.com/store/apps/details?id=com.qr.vcard&pcampaignid=web_share
    } else if (str.indexOf("iPhone") != -1) {
      str1 = "https://apps.apple.com/us/app/microsoft-copilot/id6472538445";
    }
    
    window.location.href = str1;
    console.log(str);
  }
}

</script>